import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = (theme) => css`
  width: 100%;
  max-width: 1190px;
  margin: 0 auto;
  min-height: 100%;
  padding: ${theme.spacing(4)} ${theme.spacing(3)};
`

export const content = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 14px 0;
`

export const header: Interpolation<Theme> = (theme) => css`
  display: block;
  margin-bottom: ${theme.spacing(4)};

  font-weight: 700;
`

export const table: Interpolation<Theme> = css`
  .table-row {
    padding: 10px 12px;
  }
`

export const badge: Interpolation<Theme> = css`
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
  line-height: 17.64px;
`

export const tooltip: Interpolation<Theme> = css`
  width: fit-content;
`
